import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { AgentPicker } from "@/components/AgentPicker";
import { toast } from "sonner";
import { UserPlus } from "lucide-react";

export const FIELDS = [["name", "Contractor name *"], ["business", "Business name"], ["phone", "Mobile phone"], ["email", "Email"],
  ["street", "Street address"], ["city", "City"], ["state", "State"], ["zip", "ZIP"], ["license_type", "License type code (e.g. CGC)"], ["license", "License #"]];
const EMPTY = { name: "", business: "", phone: "", email: "", street: "", city: "", state: "FL", zip: "", license_type: "", license: "", notes: "", agent_id: "" };

export const AddSuretyLead = ({ onDone, agents }) => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { await api.post("/surety/leads", f); toast.success("Lead added"); setF(EMPTY); setOpen(false); onDone?.(); }
    catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };
  return (
    <>
      <Button onClick={() => setOpen(true)} data-testid="surety-add-lead-btn"><UserPlus className="mr-1.5 h-4 w-4" />Add bond lead manually</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-h-[90vh] overflow-y-auto" data-testid="surety-add-lead-dialog">
          <DialogHeader><DialogTitle>Add a contractor lead</DialogTitle></DialogHeader>
          <p className="text-xs text-slate-500">Duplicates are allowed - the same contractor can be added more than once.</p>
          {agents && <AgentPicker agents={agents} value={f.agent_id} onChange={(v) => setF({ ...f, agent_id: v })} testId="surety-add-agent" />}
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            {FIELDS.map(([k, label]) => (
              <div key={k}><Label className="text-xs">{label}</Label>
                <Input value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`surety-add-${k}`} /></div>
            ))}
            <div className="sm:col-span-2"><Label className="text-xs">Notes</Label>
              <Textarea rows={2} value={f.notes} onChange={(e) => setF({ ...f, notes: e.target.value })} data-testid="surety-add-notes" /></div>
          </div>
          <DialogFooter><Button onClick={save} disabled={busy || f.name.trim().length < 2 || (agents && !f.agent_id)} data-testid="surety-add-save">Add lead</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
